import React from 'react';
import { connect } from 'react-redux';
import PeoplePicker, { mapDbUserForPeoplePicker } from '../formFields/PeoplePicker';
import { PermissionRole } from '../../GlobalConst/globalEnums';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { MessageBar, MessageBarType, PrimaryButton } from '@fluentui/react';
import { ModalDialog } from "../formFields/Dialog";
import Api from '../../services/Api'
import InfoTooltip from '../formFields/InfoTooltip';

class PermissionRoles extends React.Component
{
    constructor(props) {
        super(props);

        this.state = {
            administrators: [],
            contributors: [],
            readers: [],
            appManagers: [],
            ppCatalogManagers: [],
            isLoading: false,
            isSaving: false,
            message: null
        };
    }

    componentDidMount() {
        this.setState({
            isLoading: true
        });
        this.getUsersWithPermissionRoles();
    }

    getUsersWithPermissionRoles() {
        Api.get(`/Settings/Users?role=any`)
        .then(res => res.data)
        .then(users => {
            const administrators = users.reduce((users, user) => {
                    if(user.role === PermissionRole.administrator) {
                        users.push(mapDbUserForPeoplePicker(user));
                    }
                    return users;
                }, []);
            const contributors = users.reduce((users, user) => {
                    if(user.role === PermissionRole.contributor) {
                        users.push(mapDbUserForPeoplePicker(user));
                    }
                    return users;
                }, []);
            const readers = users.reduce((users, user) => {
                    if(user.role === PermissionRole.reader) {
                        users.push(mapDbUserForPeoplePicker(user));
                    }
                    return users;
                }, []);
            const appManagers = users.reduce((users, user) => {
                    if(user.isApplicationManager) {
                        users.push(mapDbUserForPeoplePicker(user));
                    }
                    return users;
                }, []);
            const ppCatalogManagers = users.reduce((users, user) => {
                    if(user.isPowerPlatformCatalogManager) {
                        users.push(mapDbUserForPeoplePicker(user));
                    }
                    return users;
                }, []);

            this.setState({
                administrators,
                contributors,
                readers,
                appManagers,
                ppCatalogManagers,
                isLoading: false
            });
        })
        .catch(error => {
            this.setState({
                message: {
                    type: MessageBarType.error,
                    text: 'Cannot get user settings from database: ' + error
                }
            });
        });
    }

    setUserRoles = (allUsers, selectedUsers, propertyName) => {
        selectedUsers.reduce((users, user) => {
            const existingUser = users.find(x => x.id === user.id)
            if (existingUser) {
                existingUser[propertyName] = true
            }
            else {
                users.push(user)
            }
            return users
        }, allUsers)

        return allUsers
    }

    saveSettings = () => {
        this.setState({ isSaving: true, message: null });

        // if(!this.state.administrators.filter(u => u.id === this.props.currentUser.id).length &&
        //    !window.confirm('You will no longer be administrator (not including groups). Are you sure you want to continue?')) {
        //         this.setState({ isSaving: false });
        //         return;
        // }

        var users = [...this.state.readers, ...this.state.contributors, ...this.state.administrators];
        users = this.setUserRoles(users, this.state.appManagers, 'isApplicationManager');
        users = this.setUserRoles(users, this.state.ppCatalogManagers, 'isPowerPlatformCatalogManager');

        Api.post(`/Settings/Users`, users)
        .then(res => res.data)
        .then(post => {
            if(post === 200) {
                this.setState({
                    isSaving: false,
                    message: {
                        type: MessageBarType.success,
                        text: 'Settings have been saved.'
                    }
                });
            } else {
                this.setState({
                    isSaving: false,
                    message: {
                        type: MessageBarType.error,
                        text: 'Cannot save settings: ' + post.message
                    }
                });
            }
        })
        .catch(error => {
            this.setState({ isSaving: false });
            console.log(error);
        });
    }

    onSelectedAdmin = (items) => {
        this.setState({
            administrators: items.map(u => {
                    u.role = PermissionRole.administrator;
                    return u;
                })
        });
    }
    onSelectedContributor = (items) => {
        this.setState({
            contributors: items.map(u => {
                    u.role = PermissionRole.contributor;
                    return u;
                })
        });
    }
    onSelectedReader = (items) => {
        this.setState({
            readers: items.map(u => {
                    u.role = PermissionRole.reader;
                    return u;
                })
        });
    }
    onSelectedAppManager = (items) => {
        this.setState({
            appManagers: items.map(u => {
                    u.isApplicationManager = true;
                    return u;
                })
        });
    }
    onSelectedPPCatalogManager = (items) => {
        this.setState({
            ppCatalogManagers: items.map(u => {
                    u.isPowerPlatformCatalogManager = true;
                    return u;
                })
        });
    }

    isCurrentRoleRemoved = () => {
        return this.props.role === PermissionRole.administrator && !this.state.administrators.filter(u => u.id === this.props.currentUser.id).length
    }

    render() {
        
        const message = this.state.message ? 
                        <MessageBar messageBarType={this.state.message.type}>
                            {this.state.message.text}
                        </MessageBar> : null;

        const administatorDescription = 
            <div>
                <li><b>Settings Panel</b>: Full access to all features within the Settings Panel.</li>
                <li><b>Administration Panel</b>: Access to Site details, statistics, history, and the ability to add additional people as a Temporary Site Collection Admins valid for 72 hours.</li>
                <li><b>Edit Forms</b>: Ability to edit all fields within Site/Team and PowerApp/Flow Edit Forms. Ability to set site for long read-only.</li>
                <li><b>Task Management</b>: Authority to approve/reject all tasks.</li>
                <li><b>Customization</b>: Privilege to utilize all Custom Site/Team Templates.</li>
                <li><b>Resource Management</b>: Access to all Quotas, even those not currently active.</li>
                <li><b>App Permissions</b>: Access to grant and modify Sites.Selected application permissions for all sites.</li>
            </div>

        const contributorsDescription = 
            <div>
                <li><b>Administration Panel</b>: Entry to the Administration Panel, encompassing Site details, statistics, and history.</li>
                <li><b>Edit Forms</b>: Capability to edit all editable fields within Site/Team Edit Form, excluding URL changes.</li>
                <li><b>PowerApp/Flow Edit Form</b>: Access to edit all editable fields in PowerApp/Flow Edit Form.</li>
                <li><b>App Permissions</b>: Access to grant and modify Sites.Selected application permissions for all sites.</li>
            </div>

        const readersDescription = 
            <div>
                <li><b>Administration Panel</b>: Entry to the Administration Panel, encompassing Site details, statistics, and history.</li>
            </div>

        const appManagersDescription =
            <div>
                Receive task for accepting Quota after Line Manager approval.
            </div>

        return (
            <div>
                {this.state.isLoading
                 ? <Spinner style={{margin: '200px'}} size={SpinnerSize.large} />
                 :  <div className='settings-container'>
                    <div>
                        <h3>Security Roles</h3>
                        {
                            this.props.role === PermissionRole.administrator &&
                            <div className='settings-item'>
                                <div className="settings-item-title">Administrators <InfoTooltip content={administatorDescription} /></div>
                                <PeoplePicker
                                    defaultUsers={this.state.administrators}
                                    onSelectedUsers={this.onSelectedAdmin} 
                                    includeGroups={true}
                                />
                            </div>
                        }
                        <div className='settings-item'>
                            <div className="settings-item-title">Contributors <InfoTooltip content={contributorsDescription} /></div>
                            <PeoplePicker
                                defaultUsers={this.state.contributors}
                                onSelectedUsers={this.onSelectedContributor} 
                                includeGroups={true}
                            />
                        </div>
                        <div className='settings-item'>
                            <div className="settings-item-title">Readers <InfoTooltip content={readersDescription} /></div>
                            <PeoplePicker
                                defaultUsers={this.state.readers}
                                onSelectedUsers={this.onSelectedReader} 
                                includeGroups={true}
                            />
                        </div>
                    </div>
                    <div style={{marginTop: '40px'}}>
                        <h3>Process Roles</h3>
                        <div className='settings-item'>
                            <div className="settings-item-title">Quota Application Managers <InfoTooltip content={appManagersDescription} /></div>
                            <PeoplePicker
                                defaultUsers={this.state.appManagers}
                                onSelectedUsers={this.onSelectedAppManager} 
                                includeGroups={false}
                            />
                        </div>
                        <div className='settings-item'>
                            <div className="settings-item-title">Power Platform Catalog Managers</div>
                            <PeoplePicker
                                defaultUsers={this.state.ppCatalogManagers}
                                onSelectedUsers={this.onSelectedPPCatalogManager} 
                                includeGroups={false}
                            />
                        </div>
                    </div>
                    <div className='settings-btn'>
                    {
                        this.state.isSaving
                        ? <Spinner size={SpinnerSize.large} />
                        :   this.isCurrentRoleRemoved()
                            ? <ModalDialog
                                title='Administrator warning'
                                text='You will no longer be administrator (not including groups). Are you sure you want to continue?'
                                buttonName='Save'
                                actionConfirmed={this.saveSettings}
                                btnPrimary={true}
                                onCancel={() => {this.setState({ isSaving: false, message: null })}}
                                />
                            : <PrimaryButton onClick={this.saveSettings}>Save</PrimaryButton>
                    }
                    </div>
                    {message}
                    </div>
                }
            </div>
        );
    }
}
const mapStateToProps = state => ({
    currentUser: state.user.currentUser,
    role: state.user.role
});

export default connect(mapStateToProps, null)(PermissionRoles);


// WEBPACK FOOTER //
// ./src/components/Settings/PermissionRoles.js